import React from 'react'

import { Container, ContentHeader, Page } from 'components'
import { Form } from './components'

const PhishingNew = () => {
  return (
    <Page title="Nova Campanha">
      <Container maxWidth={false}>
        <ContentHeader title="Nova Campanha" />
        <Form />
      </Container>
    </Page>
  )
}

export default PhishingNew
